// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"7":"ca90c326c1267f9dfa25","96":"084d00ae1d81674da561"}[chunkId] + ".js";
};